import AuthService from '../../../services/auth/authService';
// import router from './../../../router'
import FrontendService from '../../../services/frontendService';
const fes = new FrontendService()
const api = new AuthService()
const state = {
    user: localStorage.getItem(fes.SESSION_USERNAME),
    authenticated_user: JSON.parse(localStorage.getItem(fes.SESSION_USER_AUTHENTICATED)),
    // token: localStorage.getItem(fes.SESSION_TOKEN),
    // refresh_token: localStorage.getItem(fes.SESSION_REFRESH_TOKEN),
    authLoading: null
};
const getters = {
    isAuthenticated: () => !!JSON.parse(localStorage.getItem(fes.SESSION_USER_AUTHENTICATED)) && !!localStorage.getItem(fes.SESSION_USERNAME),//!!state.user && !!state.authenticated_user,
    StateUser: () => localStorage.getItem(fes.SESSION_USERNAME),//state.user,
    StateAuthenticatedUser: () => JSON.parse(localStorage.getItem(fes.SESSION_USER_AUTHENTICATED)),//state.authenticated_user,
    StateAuthLoading: state => state.authLoading,
};
const mutations = {
    // setUser(state, value){ state.user = value },
    // setAuthenticatedUser(state, value){ state.authenticated_user = value },
    setAuthLoading(state, value){ state.authLoading = value },
};
const actions = {
    async LogIn({commit, dispatch }, user) {
        dispatch
        commit('setAuthLoading', 'login')
        try{
            const response = await api.authenticate({...user});
            localStorage.setItem(fes.SESSION_TOKEN, response.data.access);
            localStorage.setItem(fes.SESSION_REFRESH_TOKEN, response.data.refresh);
            localStorage.setItem(fes.SESSION_USERNAME, user.username);
            localStorage.setItem(fes.SESSION_USER_AUTHENTICATED, JSON.stringify(response.data.auth))
            // commit("setAuthenticatedUser", response.data.auth);
            // commit("setUser", user.username);
            commit('setAuthLoading', null)
            dispatch('gotoRoute', {name:'index'})
            return response
        }catch(error){
            commit("setAlerts", [error.toast_message])
        }
        commit('setAuthLoading', null)
    },
    async LogOut({ commit, dispatch }, alert=null) {
        commit('setAuthLoading', 'logout')
        await dispatch('removeAuth')
        let logout = {
            tag: 'warn',
            title: 'Logout',
            message:`Desconectando...`
        }
        if (!alert){
            // console.log('!alert', logout)
            commit("setAlerts", [ logout ])
        }else{
            // console.log('!alert else', alert)
            commit("setAlerts", [ alert ])
        }
        commit('setAuthLoading', null)
        // dispatch('gotoRoute', {name:'login'})
        // IMPORTANTE: Desconsiderando gotoRoute no Logout para evitar conflito no fluxo de vida do componente
        // Websocket Session_user que envia o id do usuário concatenado ao nome do channel
        // sendo assim, é necessário atualizar a página para inicializar na condicão de v-if
        location.reload()
    },
    removeAuth({ commit }){
        commit
        localStorage.removeItem(fes.SESSION_TOKEN)
        localStorage.removeItem(fes.SESSION_REFRESH_TOKEN)
        localStorage.removeItem(fes.SESSION_USERNAME)
        localStorage.removeItem(fes.SESSION_USER_AUTHENTICATED)
        // commit("setUser", null);
        // commit("setAuthenticatedUser", null);
    },
};
export default {
  state,
  getters,
  actions,
  mutations
};